import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableSortLabel,
} from "@mui/material";
import {
  StyledMainBox,
} from "../../../components/commonComponents/StyledComponents/styled";
import { ArrowDropDown, ArrowDropUp, Close } from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { useSelector } from "react-redux";
import {
  ExtraPaddingLeftStyledCell,
  LeftStyledTableCell,
} from "../../../components/commonComponents/TabularLists/styles";

const CustomSortIcon = ({ direction }) =>
  direction === 'asc' ? <ArrowDropUp /> : <ArrowDropDown />;

const ActivityInfo = ({ open, usedFor, size, closeModal, gtinInfo }) => {
  const activityDetails = useSelector((state) => state.userSelections);

  const gtinDescriptions = gtinInfo.gtin.map((gtinNum) => {
    const gtinVals = activityDetails.gtin_list.filter((item) => {
      return Number(item.value) === Number(gtinNum);
    });

    return {
      gtin: gtinNum,
      description: gtinVals.length !== 0 ? gtinVals[0].description : gtinNum,
    };
  });

  const [sortConfig, setSortConfig] = useState({
    key: "gtin",
    direction: "asc",
  });

  const handleSort = (key) => {
    setSortConfig((prevState) => {
      const isAsc = prevState.key === key && prevState.direction === "asc";
      return { key, direction: isAsc ? "desc" : "asc" };
    });
  };

  const sortedData = [...gtinDescriptions].sort((a, b) => {
    const order = sortConfig.direction === "asc" ? 1 : -1;
    const aVal = a[sortConfig.key]?.toString().toLowerCase();
    const bVal = b[sortConfig.key]?.toString().toLowerCase();
    if (aVal < bVal) return -1 * order;
    if (aVal > bVal) return 1 * order;
    return 0;
  });

  return (
    <Dialog
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth
      maxWidth={size}
    >
      <DialogTitle>Marketing Activity GTINs</DialogTitle>
      <DialogContent>
        <StyledMainBox component="main">
          <Box sx={{ display: "flex" }}>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
              <Table sx={{ minWidth: 700 }} aria-label="marketing activities">
                <TableHead>
                  <TableRow>
                    <ExtraPaddingLeftStyledCell sortDirection={sortConfig.key === "gtin" ? sortConfig.direction : false}>
                      <TableSortLabel
                        active={sortConfig.key === "gtin"}
                        direction={sortConfig.key === "gtin" ? sortConfig.direction : "asc"}
                        onClick={() => handleSort("gtin")}
                        hideSortIcon={false}
                        IconComponent={() => (
                          <CustomSortIcon direction={sortConfig.key === "gtin" ? sortConfig.direction : "asc"} />
                        )}
                        sx={{
                          color: "white !important",
                          '& .MuiTableSortLabel-icon': {
                            opacity: "1!important",
                            color: "white !important",
                            visibility: 'visible !important',
                          },
                        }}
                      >
                        GTIN
                      </TableSortLabel>
                    </ExtraPaddingLeftStyledCell>
                    <LeftStyledTableCell sortDirection={sortConfig.key === "description" ? sortConfig.direction : false}>
                      <TableSortLabel
                        active={sortConfig.key === "description"}
                        direction={sortConfig.key === "description" ? sortConfig.direction : "asc"}
                        onClick={() => handleSort("description")}
                        hideSortIcon={false}
                        IconComponent={() => (
                          <CustomSortIcon direction={sortConfig.key === "description" ? sortConfig.direction : "asc"} />
                        )}
                        sx={{
                          color: "white !important",
                          '& .MuiTableSortLabel-icon': {
                            opacity: "1!important",
                            color: "white !important",
                            visibility: 'visible !important',
                          },
                        }}
                      >
                        Article Description
                      </TableSortLabel>
                    </LeftStyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedData.map((activity) => (
                    <TableRow key={activity.gtin + "_activity"}>
                      <ExtraPaddingLeftStyledCell component="td" scope="row" className="text-wrapper wrapLargeText">
                        {activity.gtin}
                      </ExtraPaddingLeftStyledCell>
                      <LeftStyledTableCell component="td" scope="row" className="text-wrapper">
                        {activity.description}
                      </LeftStyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </StyledMainBox>
      </DialogContent>
      <Box height={20} />
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
          <CloseButton
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
            label="Close"
            icon={<Close />}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityInfo;
